/* VISITOR SETTINGS — one localStorage entry for every hub preference
   --------------------------------------------------------------------------
   All per-visitor settings live in a single JSON object under SETTINGS_KEY,
   for example {"theme":"system","referenceView":"Api"}. A new preference is a
   new property here, never a new localStorage key.

     theme          'light' | 'dark' | 'system'        (theme.js)
     referenceView  'Frontend' | 'Api' | 'Backend'     (reference.js; the
                    platform's names, shown to readers as Templates, API & Jobs
                    and Admin)
     templateEngine 'smarty' | 'twig'                  (template-code.js; the
                    engine every Template code component shows)
     apiLanguage    'http' | 'curl' | 'php' | 'python' | 'js'
                                                       (api-example.js; the
                    language every API example shows)

   The pre-paint script in includes/frontend/base-template.html reads the same
   entry before first paint. Change the key or the shape there too.

   Reading progress on the home page (hub:read, hub:open, hub:depth in
   home-progress.js) is history rather than settings, written on scroll, and
   deliberately stays in its own keys.

   Every access is wrapped: storage can be missing, full or blocked (private
   windows, disabled site data), and a preference must never break a page. */

export var SETTINGS_KEY = 'hub:settings';

/* The theme used to be a bare string under its own key. Read it once, move it
   into the shared entry and drop the old key, so a returning visitor keeps
   the theme they picked. */
var LEGACY_THEME_KEY = 'cd-theme';

function load() {
	var raw = null;
	try { raw = localStorage.getItem(SETTINGS_KEY); } catch (e) { return {}; }
	if (!raw) { return {}; }
	try {
		var value = JSON.parse(raw);
		return (value && typeof value === 'object' && !Array.isArray(value)) ? value : {};
	} catch (e) {
		return {};
	}
}

function save(settings) {
	try { localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings)); } catch (e) {}
}

export function readSettings() {
	var settings = load();
	if (settings.theme === undefined) {
		var legacy = null;
		try { legacy = localStorage.getItem(LEGACY_THEME_KEY); } catch (e) {}
		if (legacy) {
			settings.theme = legacy;
			save(settings);
			try { localStorage.removeItem(LEGACY_THEME_KEY); } catch (e) {}
		}
	}
	return settings;
}

/* Merge, not replace: one feature writing its setting must not wipe another's. */
export function writeSettings(patch) {
	var settings = readSettings();
	Object.keys(patch).forEach(function (key) { settings[key] = patch[key]; });
	save(settings);
	return settings;
}
